import { render, staticRenderFns } from "./publishHistory.vue?vue&type=template&id=4919da4a&scoped=true"
import script from "./publishHistory.vue?vue&type=script&lang=js"
export * from "./publishHistory.vue?vue&type=script&lang=js"
import style0 from "./publishHistory.vue?vue&type=style&index=0&id=4919da4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4919da4a",
  null
  
)

export default component.exports